import { useEffect, useState } from "react";
import {
  bgMap,
  borderColorMap,
  ColorType,
  pureBgMap,
} from "../../shared/colors";
import { cn } from "../../lib/utils";

const PageProgress2 = ({
  color,
  pathWidth = 2,
}: {
  color: ColorType;
  pathWidth?: number;
}) => {
  const [scroll, setScroll] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const scrollHandler = () => {
      const scrollY = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;

      setScroll((scrollY / (documentHeight - windowHeight)) * 100);

      if (scrollY > 1) setShow(true);
      else setShow(false);
    };

    window.addEventListener("scroll", scrollHandler);
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  return (
    <div
      className={cn(
        "fixed right-2 top-[50%] translate-y-[-50%] z-50 cursor-pointerw-4 border h-40",
        show ? "block" : "hidden",
        borderColorMap[color]
      )}
    >
      <div
        className={cn("h-full rounded-sm relative", bgMap[color])}
        style={{ width: pathWidth }}
      >
        <div
          className={cn("absolute w-full rounded-sm", pureBgMap[color])}
          style={{
            height: `${scroll}%`,
          }}
        />
      </div>
    </div>
  );
};

export default PageProgress2;
